import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  UsersIcon,
  ChartBarIcon,
  ArrowLeftIcon,
  PlusIcon,
  DocumentTextIcon
} from '@heroicons/react/24/outline';
import { getStatisticsOverview } from './services/api.ts';

const AdminPanel = () => {
  const navigate = useNavigate();
  const [statistics, setStatistics] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStatistics();
  }, []);

  const fetchStatistics = async () => {
    try {
      setLoading(true);
      const data = await getStatisticsOverview();
      setStatistics(data);
    } catch (error) {
      console.error('Error fetching statistics:', error);
    } finally {
      setLoading(false);
    }
  };

  const adminSections = [
    {
      title: 'Настройки',
      description: 'Управление интеграцией HH.ru и токеном доступа',
      icon: UsersIcon,
      path: '/recruiter/search?admin=settings',
      color: 'bg-blue-500'
    },
    {
      title: 'Статистика использования',
      description: 'Просмотр статистики по активности пользователей и поискам',
      icon: ChartBarIcon,
      path: '/recruiter/search?admin=stats',
      color: 'bg-green-500'
    },
    {
      title: 'Журнал активности',
      description: 'Просмотр последних действий пользователей в системе',
      icon: DocumentTextIcon,
      path: '/recruiter/search?admin=stats&tab=activity',
      color: 'bg-purple-500'
    }
  ];

  return (
    <div className="bg-white rounded-xl shadow p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {adminSections.map((section) => {
            const Icon = section.icon;
            return (
              <button
                key={section.title}
                onClick={() => {
                  if (section.title === 'Настройки') {
                    navigate('/recruiter/search?admin=settings', { replace: true });
                  } else if (section.title === 'Статистика использования') {
                    navigate('/recruiter/search?admin=stats', { replace: true });
                  } else {
                    navigate('/recruiter/search?admin=stats&tab=activity', { replace: true });
                  }
                }}
                className="bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow p-6 text-left"
              >
                <div className="flex items-center mb-4">
                  <div className={`${section.color} rounded-xl p-3`}>
                    <Icon className="h-6 w-6 text-white" />
                  </div>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  {section.title}
                </h3>
                <p className="text-sm text-gray-600">
                  {section.description}
                </p>
              </button>
            );
          })}
        </div>

        {/* Quick Stats */}
        <div className="mt-8">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">Быстрая статистика</h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div className="bg-white rounded-xl shadow p-4">
              <div className="text-sm text-gray-500">Всего пользователей</div>
              <div className="text-2xl font-bold text-gray-900">
                {loading ? '-' : (statistics?.totalUsers || 0)}
              </div>
            </div>
            <div className="bg-white rounded-xl shadow p-4">
              <div className="text-sm text-gray-500">Активные сегодня</div>
              <div className="text-2xl font-bold text-gray-900">
                {loading ? '-' : (statistics?.activeUsers || 0)}
              </div>
            </div>
            <div className="bg-white rounded-xl shadow p-4">
              <div className="text-sm text-gray-500">Поисков сегодня</div>
              <div className="text-2xl font-bold text-gray-900">
                {loading ? '-' : (statistics?.todaySearches || 0)}
              </div>
            </div>
            <div className="bg-white rounded-xl shadow p-4">
              <div className="text-sm text-gray-500">Всего поисков</div>
              <div className="text-2xl font-bold text-gray-900">
                {loading ? '-' : (statistics?.totalSearches || 0)}
              </div>
            </div>
          </div>
        </div>
    </div>
  );
};

export default AdminPanel;